exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-88225860],.fade-leave-active[data-v-88225860]{transition:opacity .2s}.fade-enter[data-v-88225860],.fade-leave-to[data-v-88225860]{opacity:0}", ""]);

// exports
